<template>
  <w-setting-sliding-popup ref="slidingPopup" width="600px" :title="titleName" @close="onClose">
    <div slot="content">
      <el-row type="flex" justify="start" align="middle" style="height: 40px; margin-bottom: 8px;">
        <el-row tyle="flex" class="mr-r10">
          템플릿 종류
        </el-row>
        <el-select :disabled="popupType === 'EDIT'" v-model="targetTmplType" size="small" @change="onChangeTmplType">
          <el-option v-for="item in tmplTargetTypeList" :key="item.templateTargetType" :label="item.templateTargetTypeDesc" :value="item.templateTargetType"></el-option>
        </el-select>
      </el-row>
      <div class="title-bar title-h4 mr-t30">벤더 및 모델 정보</div>
      <el-form :model="vendorInfo" label-position="top" class="mr-b25" ref="vendorModelName">
        <el-row :gutter="20">
          <el-col :span="12">
            <!-- 벤더 유효성 검사 -->
            <el-form-item label="벤더사 명" prop="objCompanyName" :rules="{ trigger: 'blur', validator: this.validateModel }">
              <el-input :disabled="true" v-model="objCompanyName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="벤더사 OID" prop="objCompanyOid">
              <el-input :disabled="true" v-model="objCompanyOid"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 추가 팝업의 경우 multi select 제공 -->
        <el-row :gutter="20" v-if="templateModelShowFlag && popupType ==='ADD'">
          <el-col :span="24">
            <el-form-item label="모델명" prop="objProductId" :rules="{ trigger: 'blur', validator: this.validateModel }">
              <el-select multiple :disabled="popupType === 'EDIT'" v-model="selectObjProductId" style="width:100%" @change="selectProductChange">
                <el-option v-for="item in productInfoList" :key="`${item.objCompanyId}${item.objProductId}`" :label="item.objProductId" :value="item.objProductId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 수정 팝업일 경우 기본 select 제공 -->
        <el-row :gutter="20" v-if="templateModelShowFlag && popupType === 'EDIT'">
          <el-col :span="12">
            <el-form-item label="모델명" prop="objProductId" :rules="{ trigger: 'blur', validator: this.validateModel }">
              <el-select :disabled="popupType === 'EDIT'" v-model="selectObjProductId" style="width:100%" filterable :allow-create="false" @change="selectProductChange">
                <el-option v-for="item in productInfoList" :key="`${item.objCompanyId}${item.objProductId}`" :label="item.objProductId" :value="item.objProductId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="모델 OID" prop="objOid">
              <el-input :disabled="true" v-model="selectObjOid"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div v-show="templateObjShowFlag" class="mr-t20">
        <el-row type="flex" class="title-bar mr-b10" justify="space-between">
          <div class="vertical-center-box">
            <div class="title-h4">장비목록</div>
            <div class="setting-addel mr-l15">
              <el-button size="mini" icon="fas fa-check-square" :disabled="popupType === 'EDIT'" @click="checkAllList(true)"></el-button>
              <el-button size="mini" icon="fas fa-square" :disabled="popupType === 'EDIT'" @click="checkAllList(false)"></el-button>
            </div>
          </div>
          <div>
            <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
          </div>
        </el-row>
        <el-table-wrapper class="mr-r10" ref="venderDeviceTableRef" style="height: 300px;" fit-height border :data="venderDeviceTableData" :columns="venderDeviceColumns" :pagination="true"
          remote @condition-change="getVenderDeviceForTemplate" :column-default="columnDefault" :total="total" :show-custom-header="true" :show-search-tool="showSearchTool">
          <template slot-scope="scope" slot="checkFlag">
              <el-checkbox v-model="scope.row.checkFlag" :disabled="popupType === 'EDIT'" :true-label="1" :false-label="0"></el-checkbox>
          </template>
        </el-table-wrapper>
      </div>
      <hr class="mr-b15 mr-t15" />
      <!-- 구성 OID 추가 컴포넌트 -->
      <div class="mr-t20">
        <el-row tyle="flex" class="title-h4 mr-r10">
          구성 OID 추가
        </el-row>
        <el-row type="flex" class="mr-b15" justify="start" align="middle" style="height: 40px;">
          <el-row tyle="flex" class="mr-l15 mr-r10">
            구성 정보 목록
          </el-row>
          <el-select ref="selectAttrField" class="mr-r10" style="width: calc(100% - 154px);" v-model="targetAttrKey" size="small" @change="onChangeNcmAttr()">
            <el-option v-for="item in ncmAttrList" :key="item.targetAttrName" :label="item.targetAttrName"
            :value="`${item.attrTypeId}.${item.attrId}`"></el-option>
          </el-select>
          <el-button size="small" type="plain" @click="onClickAddAttrBtn()">
            <i class="fas fa-plus" />
          </el-button>
        </el-row>
        <hr class="mr-b15" />
        <!-- ncm_attr -->
        <div v-for="(item, index) in targetTmplAttrs" :key="item.templateId">
          <el-row type="flex" class="mr-b10" justify="space-between" align="middle">
            <el-row class="title-h4">
             {{index + 1}}) <span class="mr-l5">{{item.targetAttrName}}</span>
            </el-row>
            <el-button size="small" type="plain" @click="onClickDelAttrBtn(index)">
              <i class="fas fa-minus" />
            </el-button>
          </el-row>
          <!-- templateOid -->
          <el-row v-for="(tagetTemplateOid, oidIndex) in item.ncmAttrTmpl.templateOid" :key="`${tagetTemplateOid}}/${oidIndex}`" type="flex" class="mr-b10" :gutter="10">
            <el-col :span="17">
              <el-input v-model="tagetTemplateOid.oid" placeholder="OID 입력 필드"></el-input>
            </el-col>
              <el-col v-if="oidIndex < 1 && item.ncmAttrTmpl.snmpRequestType === 'GET'" :span="2" style="display: flex; justify-content: center;">
                <el-button size="small" type="plain" @click="onClickOidBtn('add', item.ncmAttrTmpl.templateOid, oidIndex)">
                  <i class="fas fa-plus" />
                </el-button>
              </el-col>
              <el-col v-if="oidIndex > 0" :span="2" style="display: flex; justify-content: center;">
                <el-button size="small" type="plain" @click="onClickOidBtn('delete', item.ncmAttrTmpl.templateOid, oidIndex)">
                  <i class="fas fa-minus" />
                </el-button>
              </el-col>
              <el-col :span="item.ncmAttrTmpl.snmpRequestType === 'GET' ? 5 : 7">
                <el-select v-if="oidIndex < 1" v-model="item.ncmAttrTmpl.snmpRequestType" @change="onChangeOidRequestType(item, ...arguments)">
                  <el-option label="GET" value="GET"></el-option>
                  <el-option label="SUBTREE" value="SUBTREE"></el-option>
                </el-select>
              </el-col>
          </el-row>
          <el-row type="flex" class="mr-b10" align="middle">
            <el-col :span="4">
              <span>정규식 패턴 :</span>
            </el-col>
            <el-col :span="20">
              <el-input v-model="item.ncmAttrTmpl.templatePattern" placeholder="정규식 입력 필드"></el-input>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between" v-for="(statusItem, statusIndex) in item.ncmAttrTmplStatus" :key="`${statusItem}/${statusIndex}`" class="mr-b10">
            <el-row style="width: calc(100% - 33px);" type="flex" align="middle" :gutter="10">
              <el-col :span="9" style="display: flex; align-items: center;">
                <span class="mr-r10" style="float: left;">수집 값 :</span>
                <el-input v-model="statusItem.statusKey" style="width: calc(100% - 60px);"></el-input>
              </el-col>
              <el-col :span="9" style="display: flex; align-items: center;">
                <span class="mr-r10" style="float: left;">표현 값 :</span>
                <el-input v-model="statusItem.statusValue" style="width: calc(100% - 60px);"></el-input>
              </el-col>
              <el-col :span="6">
                <span class="mr-r10" style="float: left;">장애 판단 :</span>
                <el-checkbox v-model="statusItem.statusFaultFlag" true-label="T" false-label="F"></el-checkbox>
                <!-- <el-row v-if="(item.ncmAttrTmpl.attrId !== 'FAN_STATE') && (item.ncmAttrTmpl.attrId !== 'POWER_STATE')" type="flex" align="middle">
                </el-row> -->
              </el-col>
            </el-row>
            <div style="width: 33px;">
              <el-button v-if="statusIndex < 1" size="small" type="plain" @click="onClickAddStatusBtn(item)">
                <i class="fas fa-plus" />
              </el-button>
              <el-button v-if="statusIndex > 0" size="small" type="plain" @click="onClickDelStatusBtn(item, statusIndex)">
                <i class="fas fa-minus" />
              </el-button>
            </div>
          </el-row>
          <hr class="mr-b15"/>
        </div>
      </div>
    </div>
    <el-row slot="footer" type="flex" justify="center">
      <el-button size="large" type="solid" class="mr-r4" @click="saveConfigOidList">저장</el-button>
      <el-button size="large" @click="closePopup">취소</el-button>
    </el-row>
  </w-setting-sliding-popup>
</template>

<script>
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';
import { isNil, clone, isEmpty, forEach, cloneDeep, isUndefined } from 'lodash';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import { isTrue } from '@/utils/boolean';

export default {
  name: 'WConfigOidPopup',
  props: {
    editRow: Object,
    popupType: String,
    selectVendor: Object,
    tmplTargetTypeList: Array,
  },
  data() {
    return {
      columnDefault,
      titleName: '',
      selectObjProductId: [],
      selectObjOid: null,
      targetTmplType: '',
      objCompanyOid: null,
      objCompanyName: null,
      productInfoList: [],
      targetTmplAttrs: [],
      targetAttrKey: null,
      showSearchTool: false,
      total: null,
      findAttrData: {},
      ncmAttrList: [],
      venderDeviceTableData: [],
      vendorInfo: {
        objCompanyId: null,
        objProductId: null,
        objOid: null,
        objtypeId: null,
        objCompanyName: null,
        templateGroupId: null,
      },
      venderDeviceColumns: [
        {
          width: 90,
          scopedSlot: 'checkFlag',
          label: '선택',
        },
        {
          prop: 'objName',
          label: '장비 명',
          remoteProp: 'o.obj_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          remoteProp: 'ipaddress',
          sortable: true,
          searchable: true,
        },
      ],
      copyGroupId: null,
      selectedOids: [],
    };
  },
  computed: {
    templateModelShowFlag() {
      return this.targetTmplType === 'TARGET_OBJ_OID';
    },
    templateObjShowFlag() {
      return this.targetTmplType === 'TARGET_OBJ';
    },
  },
  watch: {
    selectVendor: {
      handler() {
        if (!isNil(this.selectVendor)) {
          this.objCompanyName = this.selectVendor.objCompanyName;
          this.objCompanyOid = this.selectVendor.objCompanyOid;
        }
      },
      immediate: true,
    },
    /**
     * editRow - 팝업 타입이 EDIT일 경우 더블클릭한 row의 templateGroupId, objCompanyID 해당하는 데이터 조회
     * 수정시 더블 클릭한 row는 테이블용으로 row가 세팅되어 있어서 디테일 데이터는 다시 조회한다. (동적 병합 테이블)
     * @author Song
     */
    editRow: {
      handler(row) {
        this.vendorInfo = clone(row);
        if (this.popupType === 'ADD') {
          this.titleName = '구성 OID 정보 추가';
          this.targetTmplType = 'TARGET_VENDER_ID';
          if (this.copyGroupId) {
            // template_group_id에 해당하는 attr 리스트를 조회한다.
            const params = {
              templateGroupId: this.copyGroupId,
              objCompanyId: this.selectVendor.objCompanyId,
              type: 'copy',
              tmplType: this.targetTmplType,
              objProductId: cloneDeep(this.selectObjProductId),
            };
            this.getTargetAttrTmplStatusFtn(params);
          }
        } else if (this.popupType === 'EDIT') {
          this.titleName = '구성 OID 정보 수정';
          this.selectObjProductId = row.dictInfo;
          this.selectObjOid = row.objOid;
          this.targetTmplType = row.templateTargetType;
          // template_group_id에 해당하는 attr 리스트를 조회한다.
          const params = {
            templateGroupId: row.templateGroupId,
            objCompanyId: this.selectVendor.objCompanyId,
            type: 'edit',
          };
          this.getTargetAttrTmplStatusFtn(params);
        }
        this.loadProductList();
        this.getVenderDeviceForTemplate();
        // ncm_attr 리스트를 조회한다.
        NetdeviceSettingAPI.getNcmAttrList().then((result) => {
          if (result.data.success) {
            this.ncmAttrList = result.data.data;
          }
        });
      },
      immediate: true,
    },
    // 유효성 검사 - TARGET_OBJ_OID 모델
    selectObjProductId(value) {
      if (isEmpty(value)) {
        const form = this.$refs.vendorModelName;
        if (!isEmpty(form)) {
          form.validateField('objProductId');
        }
        return;
      }
      this.$nextTick(() => {
        const form = this.$refs.vendorModelName;
        if (!isEmpty(form)) {
          form.validateField('objProductId');
        }
      });
    },
  },
  methods: {
    open(copyGroupId) {
      if (copyGroupId) {
        this.copyGroupId = copyGroupId;
      }
      this.$refs.slidingPopup.open();
    },
    onClose() {
      this.$refs.vendorModelName.resetFields();
      this.$refs.vendorModelName.clearValidate();
      this.targetTmplAttrs = [];
      this.targetAttrKey = null;
      this.selectObjProductId = null;
      this.selectObjOid = null;
      this.copyGroupId = null;
    },
    closePopup() {
      this.$refs.slidingPopup.close();
    },
    /**
     * 구성 OID 추가 - 유효성 검사 (벤더/모델 중복, 구성정보 값 유효성, 치환 값 설정 중복 및 공백 체크)
     * @return {[type]} [description]
     * @author Song
     */
    saveConfigOidList() {
      if (this.targetTmplAttrs.length < 1) {
        this.$message(msgUtil.getCustomMsgData('하나 이상의 구성 OID 정보를 추가해주세요.'));
        return;
      }
      const objIds = this.getSelectedObjids(); // 장비템플릿 > 선택한 장비를 가져온다.
      // 입력한 값에 대한 유효성 검사
      this.$refs.vendorModelName.validate((valid) => {
        if (valid) {
          let duplicateFlag = false; // 중복값 플래그
          let tmplOidFlag = false; // OID 플래그
          let attrValidFlag = false; // 구성 attr 플래그
          let attrKeys = [];

          // 구성 OID 입력한 템플릿들에 대한 유효성 검사
          forEach(this.targetTmplAttrs, (templ) => {
            templ.selectedObjIds = objIds; // 장비템플릿 - 선택한 ObjId 전달
            attrKeys = [];
            let dupliCount = null;
            // OID 공백 체크, [ncmAttrTmpl 가공]
            forEach(templ.ncmAttrTmpl.templateOid, (item) => {
              if (item.oid === '') {
                tmplOidFlag = true;
              }
            });
            // key 중복검사, 유효성 검사, [ncm_attr_tmpl_status 가공]
            forEach(templ.ncmAttrTmplStatus, (attr, index) => {
              if (attr.statusKey === '' && attr.statusValue !== '') {
                attrValidFlag = true;
              } else if (attr.statusKey !== '' && attr.statusValue === '') {
                attrValidFlag = true;
              }
              if (index === 0) {
                attrKeys.push(attr.statusKey);
              } else {
                dupliCount = attrKeys.indexOf(attr.statusKey);
              }
              // 중복된 값이 발견되었다면 플래그를 변환
              if (index > 0 && dupliCount < 0) {
                attrKeys.push(attr.statusKey);
              } else if (index > 0) {
                duplicateFlag = true;
              }
            });
          });
          if (duplicateFlag) {
            this.$message(msgUtil.getCustomMsgData('수집 값은 중복될 수 없습니다.'));
          } else if (attrValidFlag) {
            this.$message(msgUtil.getCustomMsgData('수집, 표현 값 설정 시 공백일 수 없습니다.'));
          } else if (tmplOidFlag) {
            this.$message(msgUtil.getCustomMsgData('구성 OID 값은 공백일 수 없습니다.'));
          } else if (this.targetTmplType === 'TARGET_OBJ' && objIds.length < 1) {
            this.$message(msgUtil.getCustomMsgData('장비를 하나 이상 선택해주세요.'));
          } else if (this.popupType === 'ADD') {
            const selectedProductList = [];
            forEach(this.selectObjProductId, (target) => {
              const targetRow = this.productInfoList.find((item) => item.objProductId === target);
              selectedProductList.push(targetRow);
            });
            const params = {
              templateList: cloneDeep(this.targetTmplAttrs),
              selectedProductList,
            };
            // 입력 Oid값 가공
            this.templateOidToString(params);
            const target = '구성 OID';
            const action = msgUtil.action.ADD;

            // 추가 api 호출
            NetdeviceSettingAPI.insertConfigTemplate(params).then((result) => {
              if (result.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.closePopup();
                this.$emit('reload-data');
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            });
          } else if (this.popupType === 'EDIT') {
            const targetTmplAttrsParams = cloneDeep(this.targetTmplAttrs);
            this.templateOidToString(targetTmplAttrsParams);
            const params = {
              insertTemplate: [],
              modiTemplate: [],
              delTemplate: [],
            };
            forEach(this.targetTmplAttrsOrigin, (item) => {
              const resultList = targetTmplAttrsParams.find((target) => target.templateId === item.templateId);
              if (isUndefined(resultList)) {
                // delete시에는 Origin 값에서 가져온다. Origin 데이터에는 selectedObjIds 정보가 없어 추가해준다.
                item.selectedObjIds = objIds;
                item.ncmAttrTmpl.templateOid = '';
                params.delTemplate.push(item);
              } else {
                params.modiTemplate.push(resultList);
              }
            });
            forEach(targetTmplAttrsParams, (item) => {
              const resultList = this.targetTmplAttrsOrigin.find((target) => target.templateId === item.templateId);
              if (isUndefined(resultList)) {
                params.insertTemplate.push(item);
              }
            });
            const target = '구성 OID';
            const action = msgUtil.action.MODIFY;
            // 수정 api 호출
            NetdeviceSettingAPI.updateConfigTemplate(params).then((result) => {
              if (result.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.closePopup();
                this.$emit('reload-data');
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            });
          }
        } else {
          this.$message(msgUtil.getCustomMsgData('정보를 올바르게 입력해주십시오.'));
        }
      });
    },
    /**
     * 장비 모델 조회, 추가 팝업창의 경우만 모델 수정
     * @return {[type]} [description]
     * @author Song
     */
    loadProductList() {
      if (!isNil(this.selectVendor) && (this.popupType === 'ADD')) {
        NetdeviceSettingAPI.getObjProductList({ objCompanyId: this.selectVendor.objCompanyId }).then((result) => {
          if (result.data.success) {
            this.productInfoList = result.data.data;
            this.selectObjProductId = result.data.data.length > 0 ? result.data.data[0] : [];
          }
        });
      }
    },
    /**
     * 템플릿 종류에 따라 값에 대한 초기화를 실시
     * @author Song
     */
    onChangeTmplType(value) {
      this.targetTmplAttrs = [];
      this.targetAttrKey = null;
      if (this.copyGroupId) {
        this.selectObjProductId = [];
        this.selectObjOid = null;
      } else {
        this.selectObjProductId = this.productInfoList.length > 0 ? this.productInfoList[0].objProductId : [];
        this.selectObjOid = this.productInfoList.length > 0 ? this.productInfoList[0].objOid : null;
      }
      this.$refs.vendorModelName.clearValidate();

      if (value !== 'TARGET_OBJ_OID') {
        this.selectObjProductId = [];
        this.selectObjOid = null;
      }

      // 새로운 추가가 아닌 템플릿의 복제의 경우는 존재하는 템플릿을 복사하는 기능이며 이미 템플릿 타입(모델, 장비..)가 정해져있다.
      // 템플릿 타입에 따라 template_id 형식도 이미 만들어져 있기 때문에 복제-추가 되는 템플릿은 다시 조회하여 template_id를 조합해와야한다.
      if (this.copyGroupId) {
        const params = {
          templateGroupId: this.copyGroupId,
          objCompanyId: this.selectVendor.objCompanyId,
          type: 'copy',
          tmplType: this.targetTmplType,
          objProductId: 'null',
        };
        this.$nextTick(() => {
          this.getTargetAttrTmplStatusFtn(params);
        });
      }
    },
    /**
     * 벤더에 해당하는 장비 리스트 조회 - 구성 OID
     * @return {[type]} [description]
     * @author Song
     */
    getVenderDeviceForTemplate() {
      if (!isNil(this.selectVendor)) {
        if (this.popupType === 'EDIT' && this.targetTmplType !== 'TARGET_OBJ') {
          return;
        }
        this.$nextTick(() => {
          const tableParams = this.$refs.venderDeviceTableRef.getParameter();
          const params = {
            ...tableParams,
            objCompanyId: this.selectVendor.objCompanyId,
            popupType: this.popupType,
            templateGroupId: this.vendorInfo.templateGroupId,
          };
          NetdeviceSettingAPI.getVenderDeviceForTemplate(params).then((result) => {
            if (result.data.success) {
              this.venderDeviceTableData = result.data.data;
              this.total = result.data.total;
            }
          });
        });
      }
    },
    /**
     * 모델 변경 시 해당 모델 템플릿이 존재하는 지 확인 및 모델 OID값을 매핑한다.
     * @return {[type]} [description]
     * @author Song
     */
    selectProductChange(value) {
      if (value.length > 0) {
        this.selectedOids = [];
        const findObjProductData = clone(this.productInfoList.find((item) => item.objProductId === this.selectObjProductId[0]));
        this.selectObjOid = findObjProductData.objOid;

        // 모델 다중 등록을 위한 oids 저장
        forEach(value, (target) => {
          const targetRow = this.productInfoList.find((item) => item.objProductId === target);
          this.selectedOids.push(targetRow.objOid);
        });

        // 템플릿 복제의 경우 templateId를 다시 세팅해야하니 정보를 재로드 한다.
        if (this.copyGroupId) {
          this.targetTmplAttrs = [];
          this.targetAttrKey = null;
          const params = {
            templateGroupId: this.copyGroupId,
            objCompanyId: this.selectVendor.objCompanyId,
            type: 'copy',
            tmplType: this.targetTmplType,
            objProductId: value[0],
          };
          this.getTargetAttrTmplStatusFtn(params);
        }
      }
    },
    /**
     * 선택한 attr_key에 해당하는 값을 저장
     * @author Song
     */
    onChangeNcmAttr() {
      this.findAttrData = clone(this.ncmAttrList.find((item) => `${item.attrTypeId}.${item.attrId}` === this.targetAttrKey));
    },
    /**
     * 테이블에서 체크한 row들을 가져온다.
     * @return {[type]} [description]
     * @author Song
     */
    getSelectedObjids() {
      const selectedObjIds = [];
      forEach(this.venderDeviceTableData, (item) => {
        if (isTrue(item.checkFlag)) {
          selectedObjIds.push(item.objId);
        }
      });
      return selectedObjIds;
    },
    /**
     * 구성 OID 사전 추가 팝업 > 구성 OID 자원 컴포넌트 추가 버튼 클릭
     * @return {[type]} [description]
     * @author Song
     */
    onClickAddAttrBtn() {
      if (isNil(this.targetAttrKey)) {
        this.$refs.selectAttrField.focus();
        return;
      }
      this.$refs.vendorModelName.validate((valid) => {
        if (valid) {
          let targetType = '';
          let templateTarget = null;
          if (this.targetTmplType === 'TARGET_VENDER_ID') {
            targetType = '_';
            templateTarget = this.selectVendor.objCompanyId;
          } else if (this.targetTmplType === 'TARGET_OBJ_OID') {
            // 모델 추가 기준 템플릿은 첫번 째 값으로 한다.
            // 멀티 모델 추가일 경우는 서비스 단에서 추가 시 replace할 것임
            targetType = this.popupType === 'ADD' ? this.selectObjProductId[0] : this.selectObjProductId;
            templateTarget = this.selectObjOid;
          } else if (this.targetTmplType === 'TARGET_OBJ') {
            /*
              장비 템플릿의 경우 5개의 구성 OID 템플릿을 묶었다고 가정하면 5 * 선택한 장비의 수 많큼 템플릿을 생성해야한다.
              해당 targetType은 서비스단에서 선택한 objId들로 replace할 것이다.
             */
            targetType = 'TARGET_OBJ';
            templateTarget = 'TARGET_OBJ';
          }
          const targetTemplateId = `${this.selectVendor.objCompanyId}.${targetType}.${this.targetAttrKey}`;
          let duplicateCheckData = null;

          // 중복 확인
          if (this.targetTmplAttrs.length > 0) {
            duplicateCheckData = this.targetTmplAttrs.find((item) => item.templateId === targetTemplateId);
          }

          if (duplicateCheckData) {
            this.$message('이미 등록된 구성 OID입니다.', false);
            return;
          }
          // 정해진 포맷에 맞게 변수 세팅 - 해당 형식에 따라 서비스단에서 그대로 generic insert 수행할 수 있도록 한다.
          this.targetTmplAttrs.push({
            templateGroupId: this.vendorInfo.templateGroupId,
            templateId: targetTemplateId,
            templateTarget,
            templateTargetType: this.targetTmplType,
            targetAttrName: clone(`${this.findAttrData.attrTypeName}/${this.findAttrData.attrName}`),
            // generic
            ncmAttrTmpl: {
              templateId: targetTemplateId,
              attrTypeId: this.findAttrData.attrTypeId, // MODULES
              attrId: this.findAttrData.attrId, // MODULES_STATUS
              templateOid: [{ oid: '' }],
              templatePattern: '',
              snmpRequestType: 'GET',
            },
            // generic
            ncmAttrTmplStatus: [{
              templateId: targetTemplateId,
              statusKey: '',
              statusValue: '',
              statusFaultFlag: 'F',
            }],
          });
        }
      });
    },
    /**
     * 구성 OID 사전 추가 팝업 > 구성 OID 삭제 버튼
     * @return {[type]} [description]
     * @author Song
     */
    onClickDelAttrBtn(index) {
      this.targetTmplAttrs.splice(index, 1);
    },
    onClickAddStatusBtn(item) {
      item.ncmAttrTmplStatus.push({
        templateId: item.templateId,
        statusKey: '',
        statusValue: '',
        statusFaultFlag: 'F',
      });
    },
    onClickDelStatusBtn(item, index) {
      item.ncmAttrTmplStatus.splice(index, 1);
    },
    /**
     * 체크박스 전부 체크/해제 시 checkFlag가 안먹히는 현상 처리
     * @author Song
     */
    checkAllList(value) {
      if (!isNil(this.venderDeviceTableData) && this.venderDeviceTableData.length > 0) {
        forEach(this.venderDeviceTableData, (item) => {
          item.checkFlag = value;
        });
      }
    },
    onClickOidBtn(type, arr, index) {
      if (type === 'add') {
        arr.push({ oid: '' });
      } else {
        arr.splice(index, 1);
      }
    },
    // SUBTREE일 경우 templateOid를 제공하지않는다.
    onChangeOidRequestType(targetAttr, value) {
      if (value === 'SUBTREE') {
        const after = [];
        const temp = clone(targetAttr.ncmAttrTmpl.templateOid[0]);
        after.push(temp);
        targetAttr.ncmAttrTmpl.templateOid = after;
      }
    },
    /**
     * templateOid 배열 값을 DB에 저장할 시 쉼표로 구분하여 저장하기 때문에 문자열 형태로 저장한다.
     * @author Song
     */
    templateOidToString(params) {
      // 모델 중복 추가에 따라 ADD와 EDIT의 구조 depth가 달라져 아래와 같이 판단 추가
      const targetTemplateList = this.popupType === 'ADD' ? params.templateList : params;
      forEach(targetTemplateList, (tmpl) => {
        let templateOidString = '';
        forEach(tmpl.ncmAttrTmpl.templateOid, (item, index) => {
          if (index < 1) {
            templateOidString += item.oid;
          } else {
            templateOidString += `,${item.oid}`;
          }
        });
        tmpl.ncmAttrTmpl.templateOid = templateOidString;
        tmpl.templateTargetType = this.targetTmplType;
        if (this.targetTmplType === 'TARGET_OBJ_OID') {
          tmpl.templateTarget = this.selectObjOid;
        }
      });
    },
    /**
     * 구성 OID 템플릿 - 벤더, 모델 존재 유무 검사
     * @return {[type]} [description]
     * @author Song
     */
    validateModel(rule, value, callback) {
      const targetTmplType = this.targetTmplType;
      let params = {};
      let message;
      if (this.popupType === 'ADD') {
        if (!isNil(targetTmplType)) {
          if (targetTmplType === 'TARGET_VENDER_ID') {
            params = {
              templateTargetType: targetTmplType,
              templateTarget: this.selectVendor.objCompanyId,
            };
            message = '이미 구성 OID가 설정된 벤더입니다.';
          } else if (targetTmplType === 'TARGET_OBJ_OID' && rule.field !== 'objCompanyName') {
            params = {
              templateTargetType: targetTmplType,
              templateTarget: this.selectedOids,
            };
            message = '이미 구성 OID가 설정된 모델입니다.';
          } else {
            callback();
          }
        }
        if (targetTmplType === 'TARGET_OBJ_OID' && this.selectObjProductId && this.selectObjProductId.length < 1) {
          callback(new Error('필수 값입니다.'));
        } else {
          // 구성 OID 사전 - 벤더 & 모델 존재 유무 조회
          NetdeviceSettingAPI.getExistConfigVenderModel(params).then((result) => {
            if (result.data.success) {
              const res = result.data.data;
              if (res.count === 0) {
                callback();
              } else if (targetTmplType === 'TARGET_OBJ_OID') {
                callback(new Error(`${res.objProductId} 모델은 템플릿이 이미 존재합니다.`));
              } else {
                callback(new Error(message));
              }
            }
          });
        }
      } else {
        callback();
      }
    },
    /**
     * templateGroupId에 해당하는 템플릿 구성 정보를 조회한다.
     * 구성 템플릿의 template_id는 템플릿 종류에 따라 생성되는 형식이 다르므로 objProductId, templateType 변경 할 때 조회를 다시해야한다.
     * (템플릿 복제 기능이 추가됨에 따라)
     * @return {[type]} [description]
     * @author Song
     */
    getTargetAttrTmplStatusFtn(params) {
      NetdeviceSettingAPI.getTargetAttrTmplStatus(params).then((result) => {
        if (result.data.success) {
          this.targetTmplAttrsOrigin = cloneDeep(result.data.data);
          this.targetTmplAttrs = result.data.data;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/netdevice/OidSettings/ConfigOidSettings/popup/ConfigOidPopup.vue